;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { InventoryPricingReportBanner } from 'src/components/inventory-pricing-report-banner'
import { PausedSellerReasonInlineNotification } from 'src/components/paused-seller-reason-inline-notification'
import { PausedSellerReasonModal } from 'src/components/paused-seller-reason-modal'
import { NumberOfCurrentOrders } from 'src/deprecated/components/pages/dashboard/sections/NumberOfCurrentOrders'
import { ErrorBoundary } from 'src/deprecated/components/shared/ErrorBoundary'
import { PageGrid } from 'src/deprecated/components/shared/PageGrid'
import { Seo } from 'src/deprecated/components/shared/Seo'
import { PageLayoutRebranded } from 'src/deprecated/components/shared/templates/PageLayoutRebranded'
import { useUser } from 'src/deprecated/contexts/User'
import { Page as NextPage } from 'src/deprecated/types/next'
import { getTimeOfDayGreeting } from 'src/deprecated/utils/dates'

import { AddPriceList } from './sections/AddPriceList'
import { ExpiringOrders } from './sections/ExpiringOrders'
import { ExpiringPriceLists } from './sections/ExpiringPriceLists'
import { NewOrders } from './sections/NewOrders'
import { NumberOfCurrentPriceLists } from './sections/NumberOfCurrentPriceLists'

const Page: NextPage = () => {
  const user = useUser()

  const timeOfDayGreeting = getTimeOfDayGreeting()

  return (
    <>
      <PausedSellerReasonModal user={user} />

      <Seo title="Dashboard" />

      <PageLayoutRebranded.Header>
        <PageLayoutRebranded.Title>
          {timeOfDayGreeting}, {user.account}
        </PageLayoutRebranded.Title>
      </PageLayoutRebranded.Header>
      <PageLayoutRebranded.Body as="section">
        <PausedSellerReasonInlineNotification user={user} />

        <PageGrid className="gap-x-6 gap-y-6!">
          <InventoryPricingReportBanner className="col-span-full" />

          <NumberOfCurrentOrders className="col-span-full" />

          <ErrorBoundary fallback={null}>
            <NewOrders className="col-span-full h-max lg:col-span-5" />
            <ExpiringOrders className="col-span-full h-max lg:col-span-5" />
          </ErrorBoundary>

          <NumberOfCurrentPriceLists className="col-span-full" />

          <AddPriceList className="col-span-full h-max lg:col-span-5" />

          <ErrorBoundary fallback={null}>
            <ExpiringPriceLists className="col-span-full h-max lg:col-span-5" />
          </ErrorBoundary>
        </PageGrid>
      </PageLayoutRebranded.Body>
    </>
  )
}

Page.options = {
  getLayout: (page) => <PageLayoutRebranded>{page}</PageLayoutRebranded>,
}

export { Page }
